export default {
  global: {
    'send': 'Küldés',
    'save': 'Mentés',
    'confirm': 'Megerősítés',
    'cancel': 'Mégse',
    'brand': 'HeiGIT - Heidelbergi Egyetem',
    'close': 'Bezárás',
    'closeAndDoNotShowAgain': 'Zárja be, és ne mutassa újra',
    'select': 'Kijelölés',
    'yes': 'Igen',
    'no': 'Nem',
    'and': 'és',
    'noAndDonAskAgain': 'Nem (ne kérdezze meg többször)',
    'ok': 'OK',
    'polygon': 'sokszög',
    'developedByIntro': 'A szolgáltatások fejlesztője',
    'developedBy': 'HeiGIT gGmbH',
    'duration': 'Időtartam',
    'distance': 'Távolság',
    'elevation': 'Magasság',
    'profile': 'Profil',
    'options': 'Beállítások',
    'parameters': 'paraméterek',
    'custom': 'Egyedi',
    'customOverlayer': 'Egyedi fedőréteg',
    'rawRouting': 'Nyers útvonaltervezés',
    'months': {
      'january': 'Január',
      'february': 'Február',
      'march': 'Március',
      'april': 'Április',
      'may': 'Május',
      'june': 'Június',
      'july': 'Július',
      'august': 'Augusztus',
      'september': 'Szeptember',
      'october': 'Október',
      'november': 'November',
      'december': 'December'
    },
    'monthsShort': {
      'january': 'Jan.',
      'february': 'Febr.',
      'march': 'Márc.',
      'april': 'Ápr.',
      'may': 'Máj.',
      'june': 'Jún.',
      'july': 'Júl.',
      'august': 'Aug.',
      'september': 'Szept.',
      'october': 'Okt.',
      'november': 'Nov.',
      'december': 'Dec.'
    },
    'units': {
      'km': 'km',
      'mi': 'mérföld',
      'm': 'm',
      'seconds': 'másodperc',
      's': 'mp.',
      'minutes': 'perc',
      'hours': 'óra',
      'days': 'nap',
      'min': 'perc',
      'meters': 'méter',
      'lat': 'szél.',
      'lng': 'hossz.',
      'tones': 'tonna',
      't': 't',
      'kmh': 'km/h'
    },
    'layers': {
      'macrocounty': 'Makrotérség',
      'country': 'Ország',
      'region': 'Régió',
      'county': 'Megye',
      'macroregion': 'Makrorégió',
      'neighbourhood': 'Városrész',
      'locality': 'Település',
      'borough': 'Kisváros',
      'localadmin': 'Helyi közigazgatás',
      'address': 'Cím',
      'street': 'Utca',
      'venue': 'Létesítmény',
      'rawCoordinate': 'Nyers hossz., szél. koordináták',
      'notAvailable': 'Elérhetetlen',
      'postalcode': 'Irányítószám',
      'undefined': 'Meghatározatlan',
      'ocean': 'Óceán'
    },
    'population': 'Népesség',
    'green': 'Zöld',
    'noise': 'Zaj',
    'steepness': 'Meredekség',
    'surface': 'Felszín',
    'roadaccessrestrictions': 'Behajtási korlátozások',
    'waytype': 'Út típusa',
    'suitability': 'Alkalmasság',
    'waycategory': 'Útkategória',
    'tollways': 'Fizetős utak',
    'traildifficulty': 'Út nehézsége',
    'osmid': 'OSM ID',
    'countryinfo': 'Országinformációk'
  }
}
